import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { compose } from 'recompose';

import { ReactComponent as DescriptionIcon } from '../../../assets/icons/v2/notes.svg';
import { PillButton } from '../../../components/Button/ActionButtons';
import QAPContext from '../../../context/QAPContext';

import {
  Container,
  ProfileCardCircleIconButton,
  StyledIconButton,
  StyledDescriptionIcon,
  StyledPillIcon,
  ButtonTitle,
} from './styles';
import texts from './texts.json';

const ClientQuickInfoButton = ({
  className,
  iconButton,
  textIconButton,
  userId,
}) => {
  const { openQAP } = useContext(QAPContext);

  return (
    <>
      {iconButton && (
        <ProfileCardCircleIconButton onClick={() => openQAP(userId)} aria-label={texts.caption}>
          <DescriptionIcon variant="secondary" />
        </ProfileCardCircleIconButton>
      )}
      {textIconButton && (
        <StyledIconButton
          onClick={() => openQAP(userId)}
        >
          <StyledDescriptionIcon />
          <ButtonTitle>
            {texts.caption}
          </ButtonTitle>
        </StyledIconButton>
      )}
      {!iconButton && !textIconButton && (
        <Container className={className}>
          <PillButton
            onClick={() => openQAP(userId)}
            icon={<StyledPillIcon />}
            variant="info"
            size="small"
          >
            {texts.caption}
          </PillButton>
        </Container>
      )}
    </>
  );
};

ClientQuickInfoButton.propTypes = {
  className: PropTypes.string,
  userId: PropTypes.string.isRequired,
  iconButton: PropTypes.bool,
  textIconButton: PropTypes.bool,
};

ClientQuickInfoButton.defaultProps = {
  className: '',
  iconButton: false,
  textIconButton: false,
};

export default compose(
  observer,
)(ClientQuickInfoButton);
